/**
 * InvoiceHistoryModal
 *
 * Dialog surfacing the customer's full Stripe invoice history. Wraps the
 * existing `InvoicesSection`, which owns cursor-based pagination through
 * `useGetInvoicesQuery` ("Load more"). Opened from the "Show all" link in
 * `ManagementSidebar`; closing unmounts the section so pagination state
 * resets on the next open.
 */

import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import { InvoicesSection } from './InvoicesSection';

export interface InvoiceHistoryModalProps {
  open: boolean;
  onClose: () => void;
}

export const InvoiceHistoryModal: React.FC<InvoiceHistoryModalProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
    >
      Invoice History
      <IconButton aria-label="Close invoice history" onClick={onClose} edge="end" size="small">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <InvoicesSection hideHeader />
    </DialogContent>
  </Dialog>
);
